import Vue from "vue";
import VueRouter from "vue-router";
import HomeLayout from "@/layouts/HomeLayout.vue";
import AiLayout from "@/layouts/AiLayout.vue";
import MyLayout from "@/layouts/MyLayout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/LoginView.vue"),
    meta: { title: "Login" },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/auth/RegisterView.vue"),
    meta: { title: "Register" },
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("@/views/auth/ForgotView.vue"),
    meta: { title: "Forgot Password" },
  },
  {
    path: "/",
    component: HomeLayout,
    children: [
      {
        path: "/",
        name: "HomeView",
        component: () => import("@/views/home/HomeView.vue"),
        meta: { title: "Ai Video Jet - Free Ai Video Generator" },
      },
      {
        path: "/news",
        name: "NewView",
        component: () => import("@/views/home/NewView.vue"),
        meta: { title: "News" },
      },
      {
        path: "/article",
        name: "ArticleAgreement",
        component: () => import("@/views/home/ArticleAgreement.vue"),
        meta: { title: "Article" },
      },
      {
        path: "/FAQ",
        name: "FaqPage",
        component: () => import("@/views/home/FaqPage.vue"),
        meta: { title: "FAQ" },
      },
      {
        path: "/price",
        name: "PriceView",
        component: () => import("@/views/home/PriceView.vue"),
        meta: { title: "Price" },
      },
      {
        path: "/video-show",
        name: "VideoShow",
        component: () => import("@/views/home/VideoShow.vue"),
        meta: { title: "Video Show" },
      },
    ],
  },
  {
    path: "/ai",
    component: AiLayout,
    children: [
      {
        path: "/ai/reference",
        name: "Reference",
        component: () => import("@/views/ai/VideoView.vue"),
        meta: { title: "Multi-reference" },
      },
      {
        path: "/ai",
        name: "TextToVideo",
        component: () => import("@/views/ai/VideoView.vue"),
        meta: { title: "Text to Video" },
      },
      {
        path: "/ai/image-to-video",
        name: "ImageToVideo",
        component: () => import("@/views/ai/VideoView.vue"),
        meta: { title: "Image to Video" },
      },
      {
        path: "/ai/text-to-image",
        name: "TextToImage",
        component: () => import("@/views/ai/ImageView.vue"),
        meta: { title: "Text to Image" },
      },
      {
        path: "/ai/image-to-image",
        name: "ImageToImage",
        component: () => import("@/views/ai/ImageView.vue"),
        meta: { title: "Image to Image" },
      },
      {
        path: "/ai/my-creation",
        name: "MyCreation",
        component: () => import("@/views/ai/MyCreation.vue"),
        meta: { title: "My Creation" },
      },
    ],
  },
  {
    path: "/my",
    component: MyLayout,
    children: [
      {
        path: "/my",
        name: "DashboardView",
        component: () => import("@/views/my/DashboardView.vue"),
        meta: { title: "Overview" },
      },
      {
        path: "/my/my-video",
        name: "MyVideo",
        component: () => import("@/views/ai/MyCreation.vue"),
        meta: { title: "My Creation" },
      },
      {
        path: "/my/membership",
        name: "MembershipView",
        component: () => import("@/views/my/MembershipView.vue"),
        meta: { title: "Member Center" },
      },
      {
        path: "/my/credit",
        name: "CreditView",
        component: () => import("@/views/my/CreditView.vue"),
        meta: { title: "Quota Management" },
      },
      {
        path: "/my/billing",
        name: "BillingView",
        component: () => import("@/views/my/BillingView.vue"),
        meta: { title: "Billing Management" },
      },
      {
        path: "/my/task",
        name: "TaskView",
        component: () => import("@/views/my/TaskView.vue"),
        meta: { title: "Generation Tasks" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  window.scrollTo(0, 0)
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router;
